import './print.css';
import React, { useState, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';

import graph from './graph';
import { useSelector } from 'react-redux';
import { isEmptyObject } from 'helpers/formatObject';
import RefundProductToWallet from '../RefundProductToWallet';

import Barcode from 'react-barcode';

import { addCommas, digitsEnToFa } from '@persian-tools/persian-tools';
import { Box, Popover, Card, Stack, Avatar, CardHeader, Typography, IconButton, CardContent } from '@mui/material';
import { CircularProgress } from '@mui/material';

export default function Content({ model }) {
  const {
    id,
    call_me,
    fast_send,
    total_cost,
    created_at,
    demand_time,
    delivery_time,
    tracking_code,
    shop,
    status,
    customer,
  } = model;
  const [result, setResult] = useState([]);
  const { userToken } = useSelector((state) => state.auth);

  const [getData, { loading }] = useLazyQuery(graph.get.query, {
    variables: {
      ids: id,
      for_admin: 1,
    },
    context: {
      serviceName: graph.get.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const fetchData = async () => {
    try {
      const { data } = await getData();
      if (!isEmptyObject(data)) {
        const res = data[graph.get.name]?.data[0];
        setResult(res.order_details);
        console.log('result', res);
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return (
      <Stack justifyContent="center" alignItems="center" height="100%" rowGap={2}>
        <CircularProgress size={26} />
        <Typography variant="caption">در حال بارگذاری...</Typography>
      </Stack>
    );
  }

  return (
    <Stack justifyContent="space-between" height="100%" rowGap={1}>
      <Stack rowGap={1} pt={2}>
        {result.map((row, i) => {
          const introtext = row?.product_shop?.product_info?.introtext;
          return (
            <Card key={i} elevation={1}>
              <CardHeader
                sx={{ p: 1 }}
                title={
                  <Typography fontSize={14} variant="subtitle1">
                    {`${row?.product_shop?.product_info?.title} ${introtext ? introtext : ''} ${
                      row?.product_shop?.product_info?.brand?.title
                    }`}
                  </Typography>
                }
                subheader={
                  <>
                    <Typography className="no-print" fontSize={12} variant="caption">
                      {`همسان سازی: ${row.sync_status}`}
                    </Typography>
                    {row?.attribute_values &&
                      row?.attribute_values.map((attribute, i) => {
                        return (
                          <Typography key={i} fontSize={12} variant="subtitle2">
                            {attribute?.title}
                          </Typography>
                        );
                      })}
                  </>
                }
                avatar={
                  <ProductAvatar
                    media={row?.product_shop?.product_info?.media[0]?.full_url}
                    id={row?.product_shop?.product_info?.barcode}
                  />
                }
                action={
                  <>
                    <Box className="no-print">
                      <RefundProductToWallet
                        ids={id}
                        productId={row.product_shop?.id}
                        status={row?.status === 'ACTIVE'}
                        title="بازگشت هزینه محصول"
                      />
                    </Box>
                    <Box className="print-header">
                      <Stack direction="row" justifyContent="flex-end" alignItems="center" columnGap={1} rowGap={1}>
                        <BarcodeInfo data={row?.product_shop?.product_info?.barcode} />
                        <Price amount={row.total_price} number={row.number} />
                      </Stack>
                    </Box>
                  </>
                }
              />
              <Box className="no-print">
                <CardContent sx={{ p: 1 }}>
                  <Stack direction="row" justifyContent="flex-end" alignItems="center" columnGap={1} rowGap={1}>
                    <BarcodeInfo data={row?.product_shop?.product_info?.barcode} />
                    <Price amount={row.total_price} number={row.number} />
                  </Stack>
                </CardContent>
              </Box>
            </Card>
          );
        })}
      </Stack>
    </Stack>
  );
}

const ProductAvatar = ({ id, media }) => {
  const img = media ? media : '/assets/images/picture.png';
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Box>
      <Avatar
        aria-owns={open ? `mouse-over-popover-${id}` : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        onClick={() => console.log('sss')}
        src={img}
        sx={{ width: 40, height: 40 }}
      />
      <Popover
        id={`mouse-over-popover-${id}`}
        sx={{
          pointerEvents: 'none',
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        onClose={handlePopoverClose}
        // disableRestoreFocus
        hideBackdrop
      >
        <Avatar src={img} variant="rounded" sx={{ width: 300, height: 300 }} />
      </Popover>
    </Box>
  );
};

const Price = ({ amount, number }) => {
  return (
    amount > 0 && (
      <>
        <Stack
          alignItems="center"
          direction="row"
          columnGap={1}
          height={48}
          width={140}
          bgcolor="warning.lighter"
          sx={{ borderRadius: 2, overflow: 'hidden', px: 0.5 }}
        >
          <Avatar sx={{ bgcolor: 'warning.light', color: 'warning.darker', display: 'flex', flexDirection: 'column' }}>
            <Typography fontSize={14} variant="subtitle1">
              {digitsEnToFa(number)}
            </Typography>
            <Typography fontSize={10} variant="subtitle1">
              عدد
            </Typography>
          </Avatar>
          <Typography color="text.secondary" variant="subtitle1" fontSize={14}>
            {`${digitsEnToFa(addCommas(Number(amount)))}`}
            <Typography mx={0.5} fontSize={8} variant="subtitle1" component="span">
              تومان
            </Typography>
          </Typography>
        </Stack>
      </>
    )
  );
};

const BarcodeInfo = ({ data }) => {
  return (
    <Stack
      alignItems="center"
      direction="row"
      columnGap={1}
      height={48}
      width={200}
      bgcolor="#eee"
      sx={{ borderRadius: 2, overflow: 'hidden', px: 1 }}
    >
      <Barcode value={data} width={2} margin={0} height={32} fontSize={14} background="transparent" />
    </Stack>
  );
};
